/* eslint-disable  import/prefer-default-export */
import { AppState } from '../../init/rootReducer';

export const checkIfProcessing = (state: AppState, ...actionPrefixes: string[]): boolean =>
  actionPrefixes.some((action) => state.ui.processing[action] || false);
